import i18n from 'translations'

export enum REVIEW_MEDICATION_STATUSES {
  END_MEDICATION = 'endMedication',
  MEDICATION_IS_STILL_NEEDED = 'medicationStillNeeded'
}

export const REVIEW_MEDICATION_LABELS = {
  [REVIEW_MEDICATION_STATUSES.MEDICATION_IS_STILL_NEEDED]:
    i18n.t('services:Review:ReviewMedication:medicationStillNeeded'),
  [REVIEW_MEDICATION_STATUSES.END_MEDICATION]: i18n.t('services:Review:ReviewMedication:endMedication'),
}

export const REVIEW_MEDICATION_OPTIONS = [
  {
    label: REVIEW_MEDICATION_LABELS[REVIEW_MEDICATION_STATUSES.MEDICATION_IS_STILL_NEEDED],
    value: REVIEW_MEDICATION_STATUSES.MEDICATION_IS_STILL_NEEDED,
  },
  {
    label: REVIEW_MEDICATION_LABELS[REVIEW_MEDICATION_STATUSES.END_MEDICATION],
    value: REVIEW_MEDICATION_STATUSES.END_MEDICATION,
  },
]
